import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../core/services/AuthService';

@Pipe({
    name: 'imageUrl',
    standalone: false
})
export class ImageUrlPipe implements PipeTransform {

    constructor(private auth: AuthService) {
    }

    transform(url: string, type: string = 'profile'): string {
        // return `/api/files/${type}/images/${url}?token=${this.auth.token}`;
        return `${environment.imagesDomain}/api/files/${type}/images/${url}?token=${this.auth.token}`;
    }
}
